/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EmployeeBlockedTimesService {
  /**
   * @summary Get Blocked Times
   * @description Get employee blocked times with optional filters.
   */
  getBlockedTimesEmployeesBlockedTimesGet: {
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetBlockedTimesEmployeesBlockedTimesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetBlockedTimesEmployeesBlockedTimesGetSchema,
        options: {
          parameters: GetBlockedTimesEmployeesBlockedTimesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetBlockedTimesEmployeesBlockedTimesGetData, GetBlockedTimesEmployeesBlockedTimesGetError>
      >
    ): Promise<
      RequestFnResponse<GetBlockedTimesEmployeesBlockedTimesGetData, GetBlockedTimesEmployeesBlockedTimesGetError>
    >;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void
    ): ServiceOperationQueryKey<
      GetBlockedTimesEmployeesBlockedTimesGetSchema,
      GetBlockedTimesEmployeesBlockedTimesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = GetBlockedTimesEmployeesBlockedTimesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = GetBlockedTimesEmployeesBlockedTimesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetBlockedTimesEmployeesBlockedTimesGetSchema,
      GetBlockedTimesEmployeesBlockedTimesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters,
      TQueryFnData = GetBlockedTimesEmployeesBlockedTimesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetBlockedTimesEmployeesBlockedTimesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters,
      TQueryFnData = GetBlockedTimesEmployeesBlockedTimesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetBlockedTimesEmployeesBlockedTimesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetTotal = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetByParametersTotal = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             date_gte: dateGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetResults = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimesEmployeesBlockedTimesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetCombinedResults = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimesEmployeesBlockedTimesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetBlockedTimesEmployeesBlockedTimesGetSchema,
          GetBlockedTimesEmployeesBlockedTimesGetParameters,
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetBlockedTimesEmployeesBlockedTimesGetData, GetBlockedTimesEmployeesBlockedTimesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetBlockedTimesEmployeesBlockedTimesGetData, GetBlockedTimesEmployeesBlockedTimesGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useSuspenseQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetBlockedTimesEmployeesBlockedTimesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters,
      TData = GetBlockedTimesEmployeesBlockedTimesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError,
          OperationInfiniteData<TData, GetBlockedTimesEmployeesBlockedTimesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetBlockedTimesEmployeesBlockedTimesGetParameters>,
      OperationError<GetBlockedTimesEmployeesBlockedTimesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetData = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimesEmployeesBlockedTimesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getBlockedTimesEmployeesBlockedTimesGetCombinedData = qraft.employeeBlockedTimesService.getBlockedTimesEmployeesBlockedTimesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimesEmployeesBlockedTimesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetBlockedTimesEmployeesBlockedTimesGetSchema,
          GetBlockedTimesEmployeesBlockedTimesGetParameters,
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetBlockedTimesEmployeesBlockedTimesGetData,
              GetBlockedTimesEmployeesBlockedTimesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<GetBlockedTimesEmployeesBlockedTimesGetData>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<GetBlockedTimesEmployeesBlockedTimesGetData>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters
      >
    >;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends GetBlockedTimesEmployeesBlockedTimesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimesEmployeesBlockedTimesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        GetBlockedTimesEmployeesBlockedTimesGetData,
        GetBlockedTimesEmployeesBlockedTimesGetParameters
      >
    >;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void)
    ): GetBlockedTimesEmployeesBlockedTimesGetData | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void)
    ):
      | OperationInfiniteData<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetParameters
        >
      | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetBlockedTimesEmployeesBlockedTimesGetSchema,
              GetBlockedTimesEmployeesBlockedTimesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetBlockedTimesEmployeesBlockedTimesGetData,
                    GetBlockedTimesEmployeesBlockedTimesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetBlockedTimesEmployeesBlockedTimesGetSchema,
              GetBlockedTimesEmployeesBlockedTimesGetParameters
            >,
            data: GetBlockedTimesEmployeesBlockedTimesGetData | undefined,
          ]
        >;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | void)
    ):
      | QueryState<GetBlockedTimesEmployeesBlockedTimesGetData, GetBlockedTimesEmployeesBlockedTimesGetError>
      | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            GetBlockedTimesEmployeesBlockedTimesGetData,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
          GetBlockedTimesEmployeesBlockedTimesGetError
        >
      | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | undefined)
        | ServiceOperationQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
      updater: Updater<
        NoInfer<GetBlockedTimesEmployeesBlockedTimesGetData> | undefined,
        NoInfer<DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetBlockedTimesEmployeesBlockedTimesGetData | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetBlockedTimesEmployeesBlockedTimesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetBlockedTimesEmployeesBlockedTimesGetData,
              GetBlockedTimesEmployeesBlockedTimesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetBlockedTimesEmployeesBlockedTimesGetData,
                GetBlockedTimesEmployeesBlockedTimesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetBlockedTimesEmployeesBlockedTimesGetData,
          GetBlockedTimesEmployeesBlockedTimesGetParameters
        >
      | undefined;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >,
      updater: Updater<
        NoInfer<GetBlockedTimesEmployeesBlockedTimesGetData> | undefined,
        NoInfer<GetBlockedTimesEmployeesBlockedTimesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetBlockedTimesEmployeesBlockedTimesGetData | undefined>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetBlockedTimesEmployeesBlockedTimesGetSchema,
        GetBlockedTimesEmployeesBlockedTimesGetData,
        TInfinite,
        GetBlockedTimesEmployeesBlockedTimesGetParameters,
        GetBlockedTimesEmployeesBlockedTimesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
    ): void;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Times
     * @description Get employee blocked times with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimesEmployeesBlockedTimesGetSchema,
            GetBlockedTimesEmployeesBlockedTimesGetData,
            TInfinite,
            GetBlockedTimesEmployeesBlockedTimesGetParameters,
            GetBlockedTimesEmployeesBlockedTimesGetError
          >
    ): number;
    schema: GetBlockedTimesEmployeesBlockedTimesGetSchema;
    types: {
      parameters: GetBlockedTimesEmployeesBlockedTimesGetParameters;
      data: GetBlockedTimesEmployeesBlockedTimesGetData;
      error: GetBlockedTimesEmployeesBlockedTimesGetError;
    };
  };
  /**
   * @summary Create Blocked Time
   * @description Create a new employee blocked time.
   */
  createBlockedTimeEmployeesBlockedTimesPost: {
    /**
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateBlockedTimeEmployeesBlockedTimesPostBody,
        CreateBlockedTimeEmployeesBlockedTimesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateBlockedTimeEmployeesBlockedTimesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateBlockedTimeEmployeesBlockedTimesPostBody,
          CreateBlockedTimeEmployeesBlockedTimesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateBlockedTimeEmployeesBlockedTimesPostData,
          CreateBlockedTimeEmployeesBlockedTimesPostError
        >
      >
    ): Promise<
      RequestFnResponse<CreateBlockedTimeEmployeesBlockedTimesPostData, CreateBlockedTimeEmployeesBlockedTimesPostError>
    >;
    /**
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateBlockedTimeEmployeesBlockedTimesPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateBlockedTimeEmployeesBlockedTimesPostSchema,
      CreateBlockedTimeEmployeesBlockedTimesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateBlockedTimeEmployeesBlockedTimesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateBlockedTimeEmployeesBlockedTimesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockedTimeEmployeesBlockedTimesPostSchema,
        CreateBlockedTimeEmployeesBlockedTimesPostData,
        CreateBlockedTimeEmployeesBlockedTimesPostParameters,
        TVariables,
        OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateBlockedTimeEmployeesBlockedTimesPostData,
      OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateBlockedTimeEmployeesBlockedTimesPostBody,
        CreateBlockedTimeEmployeesBlockedTimesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockedTimeEmployeesBlockedTimesPostSchema,
        CreateBlockedTimeEmployeesBlockedTimesPostData,
        CreateBlockedTimeEmployeesBlockedTimesPostParameters,
        TVariables,
        OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateBlockedTimeEmployeesBlockedTimesPostData,
      OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createBlockedTimeEmployeesBlockedTimesPostTotal = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createBlockedTimeEmployeesBlockedTimesPostTotal = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockedTimeEmployeesBlockedTimesPostSchema,
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createBlockedTimeEmployeesBlockedTimesPostPendingMutationVariables = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createBlockedTimeEmployeesBlockedTimesPostMutationData = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateBlockedTimeEmployeesBlockedTimesPostData,
        OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
        MutationVariables<
          CreateBlockedTimeEmployeesBlockedTimesPostBody,
          CreateBlockedTimeEmployeesBlockedTimesPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockedTimeEmployeesBlockedTimesPostSchema,
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateBlockedTimeEmployeesBlockedTimesPostData,
          OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
          MutationVariables<
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockedTimeEmployeesBlockedTimesPostSchema,
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters,
            OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Blocked Time
     * @description Create a new employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.createBlockedTimeEmployeesBlockedTimesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateBlockedTimeEmployeesBlockedTimesPostBody,
              CreateBlockedTimeEmployeesBlockedTimesPostData,
              CreateBlockedTimeEmployeesBlockedTimesPostParameters,
              OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockedTimeEmployeesBlockedTimesPostSchema,
              CreateBlockedTimeEmployeesBlockedTimesPostBody,
              CreateBlockedTimeEmployeesBlockedTimesPostData,
              CreateBlockedTimeEmployeesBlockedTimesPostParameters,
              OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateBlockedTimeEmployeesBlockedTimesPostData,
            CreateBlockedTimeEmployeesBlockedTimesPostError,
            MutationVariables<
              CreateBlockedTimeEmployeesBlockedTimesPostBody,
              CreateBlockedTimeEmployeesBlockedTimesPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateBlockedTimeEmployeesBlockedTimesPostBody,
              CreateBlockedTimeEmployeesBlockedTimesPostData,
              CreateBlockedTimeEmployeesBlockedTimesPostParameters,
              OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockedTimeEmployeesBlockedTimesPostSchema,
              CreateBlockedTimeEmployeesBlockedTimesPostBody,
              CreateBlockedTimeEmployeesBlockedTimesPostData,
              CreateBlockedTimeEmployeesBlockedTimesPostParameters,
              OperationError<CreateBlockedTimeEmployeesBlockedTimesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateBlockedTimeEmployeesBlockedTimesPostData,
          CreateBlockedTimeEmployeesBlockedTimesPostError,
          MutationVariables<
            CreateBlockedTimeEmployeesBlockedTimesPostBody,
            CreateBlockedTimeEmployeesBlockedTimesPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateBlockedTimeEmployeesBlockedTimesPostSchema;
    types: {
      parameters: CreateBlockedTimeEmployeesBlockedTimesPostParameters;
      data: CreateBlockedTimeEmployeesBlockedTimesPostData;
      error: CreateBlockedTimeEmployeesBlockedTimesPostError;
      body: CreateBlockedTimeEmployeesBlockedTimesPostBody;
    };
  };
  /**
   * @summary Get Blocked Time
   * @description Get an employee blocked time by ID.
   */
  getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet: {
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        options: {
          parameters: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    >;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
    ): ServiceOperationQueryKey<
      GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
      GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
      GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useInfiniteQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
      TQueryFnData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useInfiniteQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
      TQueryFnData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetTotal = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetByParametersTotal = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             blocked_time_id: blockedTimeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetResults = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetCombinedResults = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useSuspenseQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
      TData = GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError,
          OperationInfiniteData<TData, GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>,
      OperationError<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetCombinedData = qraft.employeeBlockedTimesService.getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 blocked_time_id: blockedTimeId2
     *             }
     *         }
     *     ]
     * });
     * getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
      >
    >;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
      >
    >;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
    ): GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
    ):
      | OperationInfiniteData<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
                    GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
            >,
            data: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
    ):
      | QueryState<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
        >
      | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
        | ServiceOperationQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData> | undefined,
        NoInfer<DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
              GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
                GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
          GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >,
      updater: Updater<
        NoInfer<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData> | undefined,
        NoInfer<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData | undefined>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
        TInfinite,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
        GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
    ): void;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Blocked Time
     * @description Get an employee blocked time by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData,
            TInfinite,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters,
            GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError
          >
    ): number;
    schema: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema;
    types: {
      parameters: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters;
      data: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData;
      error: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError;
    };
  };
  /**
   * @summary Update Blocked Time
   * @description Update an employee blocked time.
   */
  updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch: {
    /**
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError
      >
    >;
    /**
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
      UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutation({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
        TVariables,
        OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
      OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutation({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
        TVariables,
        OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
      OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchTotal = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchTotal = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             blocked_time_id: blockedTimeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchPendingMutationVariables = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchMutationData = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 blocked_time_id: blockedTimeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
        OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
        MutationVariables<
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
          OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
          MutationVariables<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
            OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Blocked Time
     * @description Update an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             blocked_time_id: blockedTimeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
              OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
              OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError,
            MutationVariables<
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
              OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
              UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters,
              OperationError<UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData,
          UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError,
          MutationVariables<
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody,
            UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema;
    types: {
      parameters: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters;
      data: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData;
      error: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError;
      body: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody;
    };
  };
  /**
   * @summary Delete Blocked Time
   * @description Delete an employee blocked time.
   */
  deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete: {
    /**
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError
      >
    >;
    /**
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
      DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutation({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
        TVariables,
        OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
      OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutation({
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         blocked_time_id: blockedTimeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
        TVariables,
        OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
      OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteTotal = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteTotal = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             blocked_time_id: blockedTimeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeletePendingMutationVariables = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteMutationData = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 blocked_time_id: blockedTimeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
        OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
        MutationVariables<
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
          OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
          MutationVariables<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
            OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete Blocked Time
     * @description Delete an employee blocked time.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             blocked_time_id: blockedTimeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeeBlockedTimesService.deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
              OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
              OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError,
            MutationVariables<
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
              OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
              DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters,
              OperationError<DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData,
          DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError,
          MutationVariables<
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody,
            DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema;
    types: {
      parameters: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters;
      data: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData;
      error: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError;
      body: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody;
    };
  };
}
/**
 * @summary Get Blocked Times
 * @description Get employee blocked times with optional filters.
 */
export const getBlockedTimesEmployeesBlockedTimesGet = {
  schema: {
    method: 'get',
    url: '/employees/blocked_times',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetBlockedTimesEmployeesBlockedTimesGetSchema;
  [QraftServiceOperationsToken]: EmployeeBlockedTimesService['getBlockedTimesEmployeesBlockedTimesGet'];
};
/**
 * @summary Create Blocked Time
 * @description Create a new employee blocked time.
 */
export const createBlockedTimeEmployeesBlockedTimesPost = {
  schema: {
    method: 'post',
    url: '/employees/blocked_times',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateBlockedTimeEmployeesBlockedTimesPostSchema;
  [QraftServiceOperationsToken]: EmployeeBlockedTimesService['createBlockedTimeEmployeesBlockedTimesPost'];
};
/**
 * @summary Get Blocked Time
 * @description Get an employee blocked time by ID.
 */
export const getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet = {
  schema: {
    method: 'get',
    url: '/employees/blocked_times/{blocked_time_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema;
  [QraftServiceOperationsToken]: EmployeeBlockedTimesService['getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet'];
};
/**
 * @summary Update Blocked Time
 * @description Update an employee blocked time.
 */
export const updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch = {
  schema: {
    method: 'patch',
    url: '/employees/blocked_times/{blocked_time_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema;
  [QraftServiceOperationsToken]: EmployeeBlockedTimesService['updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch'];
};
/**
 * @summary Delete Blocked Time
 * @description Delete an employee blocked time.
 */
export const deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete = {
  schema: {
    method: 'delete',
    url: '/employees/blocked_times/{blocked_time_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema;
  [QraftServiceOperationsToken]: EmployeeBlockedTimesService['deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete'];
};
export const employeeBlockedTimesService = {
  getBlockedTimesEmployeesBlockedTimesGet,
  createBlockedTimeEmployeesBlockedTimesPost,
  getBlockedTimeEmployeesBlockedTimesBlockedTimeIdGet,
  updateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatch,
  deleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDelete,
} as const;
type GetBlockedTimesEmployeesBlockedTimesGetSchema = {
  method: 'get';
  url: '/employees/blocked_times';
  security: ['HTTPBearer'];
};
type GetBlockedTimesEmployeesBlockedTimesGetParameters = paths['/employees/blocked_times']['get']['parameters'];
type GetBlockedTimesEmployeesBlockedTimesGetData =
  paths['/employees/blocked_times']['get']['responses']['200']['content']['application/json'];
type GetBlockedTimesEmployeesBlockedTimesGetError =
  paths['/employees/blocked_times']['get']['responses']['422']['content']['application/json'];
type CreateBlockedTimeEmployeesBlockedTimesPostSchema = {
  method: 'post';
  url: '/employees/blocked_times';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateBlockedTimeEmployeesBlockedTimesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateBlockedTimeEmployeesBlockedTimesPostData =
  paths['/employees/blocked_times']['post']['responses']['201']['content']['application/json'];
type CreateBlockedTimeEmployeesBlockedTimesPostError =
  paths['/employees/blocked_times']['post']['responses']['422']['content']['application/json'];
type CreateBlockedTimeEmployeesBlockedTimesPostBody =
  paths['/employees/blocked_times']['post']['requestBody']['content']['application/json'];
type GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetSchema = {
  method: 'get';
  url: '/employees/blocked_times/{blocked_time_id}';
  security: ['HTTPBearer'];
};
type GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetParameters =
  paths['/employees/blocked_times/{blocked_time_id}']['get']['parameters'];
type GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetData =
  paths['/employees/blocked_times/{blocked_time_id}']['get']['responses']['200']['content']['application/json'];
type GetBlockedTimeEmployeesBlockedTimesBlockedTimeIdGetError =
  paths['/employees/blocked_times/{blocked_time_id}']['get']['responses']['422']['content']['application/json'];
type UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchSchema = {
  method: 'patch';
  url: '/employees/blocked_times/{blocked_time_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchParameters =
  paths['/employees/blocked_times/{blocked_time_id}']['patch']['parameters'];
type UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchData =
  paths['/employees/blocked_times/{blocked_time_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchError =
  paths['/employees/blocked_times/{blocked_time_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateBlockedTimeEmployeesBlockedTimesBlockedTimeIdPatchBody =
  paths['/employees/blocked_times/{blocked_time_id}']['patch']['requestBody']['content']['application/json'];
type DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteSchema = {
  method: 'delete';
  url: '/employees/blocked_times/{blocked_time_id}';
  security: ['HTTPBearer'];
};
type DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteParameters =
  paths['/employees/blocked_times/{blocked_time_id}']['delete']['parameters'];
type DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteData = null;
type DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteError =
  paths['/employees/blocked_times/{blocked_time_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteBlockedTimeEmployeesBlockedTimesBlockedTimeIdDeleteBody = undefined;
